export enum WREX_CODE_BLOCK {
    /**
     * @value Code block
     * @description The label for the "Code Block" option in the select allowing the user to format his selection in the text editor
     */
    BUTTON_LABEL = 'FRONT.TEXT_EDITOR.HEADINGS.CODE_BLOCK',
}
